import { nonOpaqueTextWhite } from "NavBar/styleConstants";

import FnrDivider from "UI/FnrDivider";

import { addOpacity } from "Utilities/Colors/colorUtils";

const NavSectionDivider = () => (
  <FnrDivider marginX={32} color={addOpacity(nonOpaqueTextWhite, 0.15)} />
);

export default NavSectionDivider;
